<template>
  <div id="alterar-municipio">
    <div class="top-menu" v-bind:class="{ fixed: isFixed }">
      <div class="container">
        <div class="top-menu-content">
          <div class="logo">
            <img
              v-if="
                $store.state.infoMunicipio != null &&
                $store.state.infoMunicipio.logotipo != ''
              "
              :src="$store.state.infoMunicipio.logotipo"
              class="logo"
              alt="êSUS Feedback"
            />
            <h3>{{ $store.state.cidade }}</h3>
          </div>
          <div class="options-user">
            <ul>
              <li>
                <a
                  href=""
                  title="Aumentar fonte"
                  v-on:click.prevent.stop="aumentarFonte()"
                  >A+</a
                >
              </li>
              <li>
                <a
                  href=""
                  title="Diminuir fonte"
                  v-on:click.prevent.stop="diminuirFonte()"
                  >A-</a
                >
              </li>
              <li>
                <a
                  href=""
                  title="Alto contraste"
                  v-on:click.prevent.stop="adjust()"
                >
                  <i class="icofont-adjust"></i>
                </a>
              </li>
              <li>
                <a href="#" v-on:click.prevent.stop="">
                  <i class="icofont-user-alt-7"></i>
                  <h3 class="name-user">
                    {{ nome }}
                  </h3>
                  <i class="icofont-caret-down"></i>
                </a>
                <ul class="second-level-menu user-menu">
                  <li v-on:click.prevent.stop="logout()">
                    <a href="#"> <i class="icofont-logout"></i> Sair</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="municipios-items">
      <div class="container main">
        <div class="row">
          <div class="col-12">
            <h3>Escolha um município:</h3>
          </div>
          <div
            v-if="loadingPage"
            class="col-lg-12 d-flex justify-content-center align-items-center"
          >
            <b-spinner
              variant="primary"
              style="width: 3rem; height: 3rem"
            ></b-spinner>
          </div>
          <div class="col-12">
            <b-card
              no-body
              class="overflow-hidden municipio-item"
              v-for="(item, index) in municipios"
              :key="index"
              @click="selecionarMunicipio(item)"
            >
              <b-row no-gutters>
                <b-col md="12">
                  <b-card-body>
                    <b-card-text>
                      <div>
                        <i class="icofont-google-map"></i>
                        {{ item.cidade.no_municipio }} - {{ item.cidade.no_uf }}
                        <br />
                        <span><strong>Perfil:</strong> {{ item.funcao }}</span>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-col>
              </b-row>
            </b-card>
          </div>
          <div v-if="error.show" class="col-lg-12">
            <b-alert show variant="danger" v-html="error.message"></b-alert>
          </div>
          <div class="col-lg-12">
            <b-alert :show="loading" variant="info">
              <b-spinner small variant="primary"></b-spinner>
              Aguarde! Carregando as informações do município...
            </b-alert>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Footer from '@/components/Footer'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Municipio from '@/services/Municipio.js'
import Equipe from '@/services/Equipe.js'

export default {
  name: 'AlterarMunicipio',
  components: {
    Footer,
    PulseLoader,
  },
  data() {
    return {
      cpf: '',
      municipios: [],
      isFixed: false,
      selectedItem: null,
      loading: false,
      loadingPage: false,
      error: {
        show: false,
        message: '',
      },
    }
  },
  async mounted() {
    await this.getMunicipios()
  },
  computed: {
    nome() {
      var arr = this.$store.state.username.split(' ')
      if (arr.length > 1) {
        var keep = arr[1][0]?.toUpperCase() != arr[1][0]
        return arr.slice(0, keep ? 3 : 2).join(' ')
      } else {
        return arr[0]
      }
    },
    exibeLogo() {
      if (this.$store.state.infoMunicipio?.exibe_logoefb == '1') {
        return true
      }
      return false
    },
  },
  methods: {
    ...mapActions(['logout']),

    /**
     * Verifica a diferença de dias
     *
     * @param {String} dataComparacao
     * @returns {Boolean}
     */
    diferencaMaiorQue6Meses(dataComparacao) {
      if (dataComparacao == null) {
        return true
      }

      // Obtém a data atual
      const dataAtual = new Date()

      // Divide a data atual em dia, mês e ano
      const diaAtual = dataAtual.getDate()
      const mesAtual = dataAtual.getMonth() + 1 // Os meses em JavaScript são baseados em zero
      const anoAtual = dataAtual.getFullYear()

      // Divide a data de comparação em dia, mês e ano
      const partesData = dataComparacao.split('/')
      const diaComparacao = parseInt(partesData[0], 10)
      const mesComparacao = parseInt(partesData[1], 10)
      const anoComparacao = parseInt(partesData[2], 10)

      // Calcula a diferença em meses
      const diferencaMeses =
        (anoAtual - anoComparacao) * 12 + (mesAtual - mesComparacao)

      // Verifica se a diferença é maior do que 6 meses
      return diferencaMeses > 6
    },

    /**
     * Busca as cidades do usuário
     */
    async getMunicipios() {
      try {
        this.loadingPage = true
        this.cpf = ''
        let userAuth = await this.$api.post('/app/auth/usuario', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (userAuth) {
          this.cpf = userAuth.data.cpf
          let response = await this.$api.post('/app/auth/usuario/municipios', {
            cpf: this.cpf,
          })
          this.municipios = response.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingPage = false
      }
    },

    /**
     * Manipula ao selecionar um município
     *
     * @param {Object} item
     */
    async selecionarMunicipio(item) {
      this.selectedItem = item

      try {
        this.error.show = false
        this.loading = true

        const cod_ibge = item.cidade.co_ibge.split('-')[0]
        const id_funcao = item.id_funcao

        //verifica se o município está ativo
        const statusMunicipio = await this.$apiPublic.get(
          '/faturamento/status/' + cod_ibge
        )
        if (statusMunicipio.data.status == '0') {
          this.error.show = true
          this.error.message =
            'Acesso temporariamente suspenso para o seu município.'
          return
        }

        let url = '/app/auth/alterar-municipio'
        const response = await this.$api.post(url, {
          uuid: this.selectedItem.id,
          cod_ibge: this.selectedItem.cidade.co_ibge,
          id_funcao: this.selectedItem.id_funcao,
        })
        if (
          response.data.error == true &&
          response.data.message == 'USUÁRIO INATIVO!'
        ) {
          this.error.show = true
          this.error.message = `Se você é um <b>Secretário</b>, por favor entre em contato com o suporte e
      solicite a ativação do seu cadastro. <br /><br />
      Se você é um <b>Administrador ou Coordenador</b>, por favor entre em
      contato com o secretário do seu município para ativar o cadastro.
      <br /><br />
      Caso o seu perfil não corresponda a nenhuma das opções anteriores, por
      favor entre em contato com o administrador do e-SUS PEC ou com o
      Coordenador municipal para ativar o cadastro.`
          return
        }

        if (
          response.data.error == true &&
          response.data.message != 'USUÁRIO INATIVO!'
        ) {
          this.error.show = true
          this.error.message = response.data.message
          return
        }

        let token = response.data.token
        this.$store.commit('updateAccessToken', token)

        // valida o usuário
        const response2 = await this.$api.post('/app/auth/token')

        // Verifica se o usuário tem permissões
        if (response2.data.permissoes == false) {
          this.error.show = true
          this.error.message =
            'Usuário sem permissões! Entre em contato com o suporte.'
          return false
        }

        // Busca a ultima atualização do município
        const responseUltimaAtualizacao = await Municipio.getUltimaAtualizacao(
          response2.data.cod_ibge
        )
        if (responseUltimaAtualizacao) {
          this.$store.commit(
            'setUltimaAtualizacao',
            responseUltimaAtualizacao.data_sincronizacao
              .split('-')
              .reverse()
              .join('/')
          )
          this.$store.commit('setSincronizadorC', {
            ultimaAtualizacao: responseUltimaAtualizacao.data_sincronizacao_c
              .split('-')
              .reverse()
              .join('/'),
            qtdDiasUltimaAtualizacao: responseUltimaAtualizacao.qtd_dias_c,
          })
        }

        // Microáreas do município
        const responseMicroareasMunicipio =
          await Municipio.getMicroAreasPorMunicipio(response2.data.cod_ibge)
        if (responseMicroareasMunicipio) {
          this.$store.commit('setMicroAreas', responseMicroareasMunicipio)
        }

        // Regras indicadores APS
        const responseRegrasIndicadoresApsMunicipio =
          await Municipio.getRegrasIndicadoresPorMunicipio(
            response2.data.cod_ibge
          )
        if (responseRegrasIndicadoresApsMunicipio) {
          this.$store.commit(
            'setRegrasIndicadoresAps',
            responseRegrasIndicadoresApsMunicipio
          )
        }

        // Os últimos registros das tabelas sincronizadas
        const responseUltimosRegistrosTabelasSincronizadas =
          await Municipio.ultimosRegistrosTabelasSincronizadas(
            response2.data.cod_ibge
          )
        if (responseUltimosRegistrosTabelasSincronizadas) {
          this.$store.commit(
            'setUltimosRegistrosTabelasSincronizadas',
            responseUltimosRegistrosTabelasSincronizadas
          )
        }

        // Equipes V2 do município
        const responseEquipesV2 = await Municipio.getEquipesPorMunicipio(
          response2.data.cod_ibge
        )
        if (responseEquipesV2) {
          this.$store.commit('setEquipesV2', responseEquipesV2)
        }

        // armazena as informações do município
        let infoMunicipio = {
          exibe_logoefb: response2.data.infoMunicipio.exibe_logoefb,
          exibe_whatsapp: response2.data.infoMunicipio.exibe_whatsapp,
          logotipo: '',
          brasao: '',
        }

        if (infoMunicipio.exibe_logoefb == '1') {
          infoMunicipio.logotipo = require('@/assets/images/logo.png')
        } else {
          if (response2.data.infoMunicipio.logotipo != null) {
            infoMunicipio.logotipo =
              this.$api.defaults.baseURL +
              '/uploads/logotipos/' +
              response2.data.infoMunicipio.logotipo
          }
        }

        // Define o brasão
        if (response2.data.infoMunicipio.brasao != null) {
          infoMunicipio.brasao =
            '/api/uploads/brasao/' + response2.data.infoMunicipio.brasao
        }

        this.$store.commit('setInfoMunicipio', infoMunicipio)

        this.$store.commit(
          'setCidade',
          this.selectedItem.cidade.no_municipio +
            ' - ' +
            this.selectedItem.cidade.no_uf
        )
        this.$store.commit('setCodIbge', response2.data.cod_ibge)
        this.$store.commit('setIdFuncao', response2.data.id_funcao)
        this.$store.commit('setFuncao', response2.data.funcao)
        this.$store.commit('setUnidadeSaude', response2.data.unidade_saude)
        this.$store.commit('setId', response2.data.id)
        this.$store.commit('setUsername', response2.data.nome)
        this.$store.commit('setCoDimProf', response2.data.co_dim_prof)
        this.$store.commit(
          'setCosDimProf',
          response2.data.cos_dim_prof != null
            ? JSON.parse(response2.data.cos_dim_prof)
            : null
        )
        this.$store.commit('setPermissoes', response2.data.permissoes)
        this.$store.commit(
          'setUltimaAtualizacaoCadastro',
          response2.data.ultima_atualizacao_cadastro
        )
        this.$store.commit('setPdf', response2.data.pdf)
        this.$store.commit('setNpsEfb', response2.data.nps_efb)
        this.$store.commit('setFotoPerfil', response2.data.foto_perfil)

        sessionStorage.removeItem('aptoAvaliacaoNps')

        // Se o usuário for o secretário, administrador ou gerente/coordenador, farmácia e outros avança direto para o dashboard, caso contrário
        // verifica se o usuário está na tabela de profissionais de saúde
        if (
          response2.data.id_funcao == 1 ||
          response2.data.id_funcao == 2 ||
          response2.data.id_funcao == 7 ||
          response2.data.id_funcao == 9 ||
          response2.data.id_funcao == 10 ||
          response2.data.id_funcao == 11 ||
          response2.data.id_funcao == 12 ||
          response2.data.id_funcao == 13
        ) {
          let dataUltimaAtualizacaoCadastro = ''
          // Verifica se o usuário precisa atualizar o cadastro
          if (this.$store.state.ultimaAtualizacaoCadastro != null) {
            dataUltimaAtualizacaoCadastro =
              this.$store.state.ultimaAtualizacaoCadastro.split(' ')[0]
          }
          const resultado = this.diferencaMaiorQue6Meses(
            dataUltimaAtualizacaoCadastro.split('-').reverse().join('/')
          )
          if (
            this.$store.state.ultimaAtualizacaoCadastro == null ||
            resultado
          ) {
            await this.$store.commit('setRequiredPasswordUpdate', true)
            this.$router.push('/atualizacao-cadastro')
            return
          }

          this.$router.push('/dashboard')
        } else {
          // verifica o profissional
          const profissional = await this.$api.get(
            '/app/profissional/' +
              this.cpf.replace(/[^\d]+/g, '') +
              '/' +
              response2.data.cod_ibge
          )

          if (profissional.data == false) {
            this.$router.push('/acesso-negado')
          } else {
            this.$store.commit('setNuCns', response2.data.nu_cns)
            this.$store.commit('setNuIne', response2.data.nu_ine)
            this.$store.commit(
              'setNuIneVinculada',
              response2.data.nu_ine_vinculada
            )
            this.$store.commit('setNuCnes', response2.data.nu_cnes)
            this.$store.commit('setUnidadeSaude', response2.data.unidade_saude)
            this.$store.commit('setMicroArea', response2.data.micro_area)

            // Verifica se o usuário precisa atualizar o cadastro
            let dataUltimaAtualizacaoCadastro = ''
            if (this.$store.state.ultimaAtualizacaoCadastro != null) {
              dataUltimaAtualizacaoCadastro =
                this.$store.state.ultimaAtualizacaoCadastro.split(' ')[0]
            }
            const resultado = this.diferencaMaiorQue6Meses(
              dataUltimaAtualizacaoCadastro.split('-').reverse().join('/')
            )
            if (
              this.$store.state.ultimaAtualizacaoCadastro == null ||
              resultado
            ) {
              await this.$store.commit('setRequiredPasswordUpdate', true)
              this.$router.push('/atualizacao-cadastro')
              return
            }

            // Se for Médico, enfermeiro, odontólogo, téc. saúde bucal, emulti redireciona para a tela de escolher lotações, recepcionista
            if (
              response2.data.id_funcao == 4 ||
              response2.data.id_funcao == 5 ||
              response2.data.id_funcao == 8 ||
              response2.data.id_funcao == 14 ||
              response2.data.id_funcao == 15
            ) {
              // Se for recepcionista ou odontólogo e não tiver um ine,redireciona direto para o dashboard
              if (
                (response2.data.id_funcao == 5 ||
                  response2.data.id_funcao == 8) &&
                this.$store.state.nu_ine == ''
              ) {
                this.$router.push('/dashboard')
                return
              }
              this.$router.push(
                '/lotacoes/' + response2.data.cod_ibge + '/' + this.cpf
              )
            } else {
              this.$router.push('/dashboard')
            }
          }
        }
        this.loading = false
      } catch (error) {
        console.log(error)
        switch (error.response.status) {
          case 500:
            this.$toast.error(
              'Erro',
              'Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.',
              {
                position: 'topRight',
              }
            )
            break
          default:
            this.$toast.error(
              'Erro',
              'Serviço temporariamente indisponível. Por favor, tente novamente mais tarde.',
              {
                position: 'topRight',
              }
            )
            break
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#alterar-municipio {
  .municipios-items {
    h3 {
      margin-bottom: 20px;
    }
    .municipio-item {
      margin-bottom: 10px;
      cursor: pointer;
      padding: 5px !important;
      p {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 20px;
        span {
          font-size: 16px;
        }
      }
      .card-body {
        padding: 15px !important;
      }
      &:hover {
        border: 2px solid;
      }
    }
  }
}
</style>
